import { makeStyles, type Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
	buttonContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
	labelContainer: {
		width: '100%',
		display: 'flex',
		marginTop: 8,
		'& h5': {
			fontSize: 14,
			marginRight: '8px !important',
		},
		'& h6': {
			fontSize: 14,
			marginRight: '8px !important',
		},
	},
}));
